import { useState } from "react";
import { Reveal } from "./Reveal";

const BEFORE =
  "https://images.unsplash.com/photo-1744044155829-610dded4cead?crop=entropy&cs=srgb&fm=jpg&q=85";
const AFTER =
  "https://images.unsplash.com/photo-1634853982486-c06f0e17940f?crop=entropy&cs=srgb&fm=jpg&q=85";

const SHOTS = [
  {
    src: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?crop=entropy&cs=srgb&fm=jpg&q=85",
    label: "Crew measuring roofline — Cherry Hill, NJ",
  },
  {
    src: "https://images.unsplash.com/photo-1633759593085-1eaeb724fc88?crop=entropy&cs=srgb&fm=jpg&q=85",
    label: "Roof prep before seamless run — Wilmington, DE",
  },
  {
    src: "https://images.unsplash.com/photo-1632759145351-1d592919f522?crop=entropy&cs=srgb&fm=jpg&q=85",
    label: "Final inspection — Doylestown, PA",
  },
  {
    src: "https://images.unsplash.com/photo-1524568292009-5c8f3fe5dcc7?crop=entropy&cs=srgb&fm=jpg&q=85",
    label: "High-flow downspout install — Princeton, NJ",
  },
];

const BeforeAfter = () => {
  const [pos, setPos] = useState(50);
  return (
    <div
      className="relative h-[340px] select-none overflow-hidden rounded-2xl border border-white/10 sm:h-[460px]"
      data-testid="before-after-slider"
    >
      <img src={BEFORE} alt="Clogged gutter before service" className="absolute inset-0 h-full w-full object-cover" />
      <img
        src={AFTER}
        alt="Clean restored gutter after service"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 0 0 ${pos}%)` }}
      />
      <div className="absolute inset-y-0 w-0.5 bg-orange-500" style={{ left: `${pos}%` }}>
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-orange-500 bg-ink font-mono text-[10px] font-bold text-orange-500">
          ⇔
        </span>
      </div>
      <span className="absolute left-4 top-4 rounded-full bg-ink/70 px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-slate-300 backdrop-blur-sm">
        Before
      </span>
      <span className="absolute right-4 top-4 rounded-full bg-orange-500 px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-ink">
        After
      </span>
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
        aria-label="Reveal after photo"
        data-testid="before-after-range"
      />
    </div>
  );
};

export const Gallery = () => (
  <section id="gallery" className="py-20 lg:py-32" data-testid="gallery-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal>
        <p className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.3em] text-orange-500">
          Proof, Not Promises
        </p>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl">
          Before <span className="text-outline">&amp;</span> <span className="text-orange-500">After</span>
        </h2>
        <p className="mt-5 max-w-2xl text-base text-slate-400">
          Drag the handle to see what a full clean-out, re-pitch and guard
          install looks like on a real tri-state home.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-14">
          <BeforeAfter />
        </div>
      </Reveal>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {SHOTS.map((shot, i) => (
          <Reveal key={shot.label} delay={i * 0.08}>
            <figure className="group overflow-hidden rounded-2xl border border-white/10" data-testid={`gallery-shot-${i}`}>
              <div className="h-52 overflow-hidden">
                <img
                  src={shot.src}
                  alt={shot.label}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="bg-ink2 px-4 py-3 text-xs font-medium text-slate-400">
                {shot.label}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
